import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// Import web components
import WebLogin from './web/pages/Login'
import WebRiyoToroku from './web/pages/RiyoToroku'
import WebTop from './web/pages/Top'
import WebUserInfo from './web/pages/UserInfo'
import WebInquiry from './web/pages/Inquiry'
import WebSatsueiDataToroku from './web/pages/SatsueiDataToroku'
import WebSatsueiDataKensaku from './web/pages/SatsueiDataKensaku'
import WebGazoKensaku from './web/pages/GazoKensaku'
import WebUserKanri from './web/pages/UserKanri'
import WebKyotenKanri from './web/pages/KyotenKanri'
import WebKigyoJohoKanri from './web/pages/KigyoJohoKanri'
import WebImageFolder from './web/pages/ImageFolder'
import WebSatsueiMemoCategory from './web/pages/SatsueiMemoCategory'
import WebSatsueiGuide from './web/pages/SatsueiGuide'
import WebShare from './web/pages/Share'
import WebProtectedRoute from './web/components/ProtectedRoute'

// Import mobile components
import AppLogin from './mobile/pages/AppLogin'
import AppTop from './mobile/pages/AppTop'
import AppConfig from './mobile/pages/AppConfig'
import AppInquiry from './mobile/pages/AppInquiry'
import AppSatsuei from './mobile/pages/AppSatsuei'
import AppSearch from './mobile/pages/AppSearch'
import AppUserInfo from './mobile/pages/AppUserInfo'
import AppKaiinToroku from './mobile/pages/AppKaiinToroku'
import AppSendResetPassword from './mobile/pages/AppSendResetPassword'
import AppResetPassword from './mobile/pages/AppResetPassword'
import AppObjectDetail from './mobile/pages/AppObjectDetail'
import AppShare from './mobile/pages/AppShare'
import MobileProtectedRoute from './mobile/components/ProtectedRoute'


function App() {
  // PC版とモバイル版のルーティング
  return (
    <Routes>
      {/* Web Routes (PC版) */}
      <Route path="/login" element={<WebLogin />} />
      <Route path="/riyoToroku" element={<WebRiyoToroku />} />
      <Route path="/inquiry" element={<WebInquiry />} />
      <Route path="/top" element={
        <WebProtectedRoute>
          <WebTop />
        </WebProtectedRoute>
      } />
      <Route path="/satsueiDataToroku" element={
        <WebProtectedRoute>
          <WebSatsueiDataToroku />
        </WebProtectedRoute>
      } />
      <Route path="/satsueiDataKensaku" element={
        <WebProtectedRoute>
          <WebSatsueiDataKensaku />
        </WebProtectedRoute>
      } />
      <Route path="/gazoKensaku" element={
        <WebProtectedRoute>
          <WebGazoKensaku />
        </WebProtectedRoute>
      } />
      <Route path="/userInfo" element={
        <WebProtectedRoute>
          <WebUserInfo />
        </WebProtectedRoute>
      } />
      <Route path="/userKanri" element={
        <WebProtectedRoute>
          <WebUserKanri />
        </WebProtectedRoute>
      } />
      <Route path="/kyotenKanri" element={
        <WebProtectedRoute>
          <WebKyotenKanri />
        </WebProtectedRoute>
      } />
      <Route path="/kigyoJohoKanri" element={
        <WebProtectedRoute>
          <WebKigyoJohoKanri />
        </WebProtectedRoute>
      } />
      <Route path="/imageFolder" element={
        <WebProtectedRoute>
          <WebImageFolder />
        </WebProtectedRoute>
      } />
      <Route path="/satsueiMemoCategory" element={
        <WebProtectedRoute>
          <WebSatsueiMemoCategory />
        </WebProtectedRoute>
      } />
      <Route path="/satsueiGuide" element={
        <WebProtectedRoute>
          <WebSatsueiGuide />
        </WebProtectedRoute>
      } />
      <Route path="/share" element={<WebShare />} />

      {/* Mobile Routes (モバイル版) */}
      <Route path="/appLogin" element={<AppLogin />} />
      <Route path="/appKaiinToroku" element={<AppKaiinToroku />} />
      <Route path="/appTop" element={
        <MobileProtectedRoute>
          <AppTop />
        </MobileProtectedRoute>
      } />
      <Route path="/appConfig" element={
        <MobileProtectedRoute>
          <AppConfig />
        </MobileProtectedRoute>
      } />
      <Route path="/appInquiry" element={<AppInquiry />} />
      <Route path="/appSatsuei" element={
        <MobileProtectedRoute>
          <AppSatsuei />
        </MobileProtectedRoute>
      } />
      <Route path="/appSearch" element={
        <MobileProtectedRoute>
          <AppSearch />
        </MobileProtectedRoute>
      } />
      <Route path="/appUserInfo" element={
        <MobileProtectedRoute>
          <AppUserInfo />
        </MobileProtectedRoute>
      } />
      <Route path="/appSendResetPassword" element={<AppSendResetPassword />} />
      <Route path="/appResetPassword" element={<AppResetPassword />} />
      <Route path="/appObjectDetail" element={
        <MobileProtectedRoute>
          <AppObjectDetail />
        </MobileProtectedRoute>
      } />
      <Route path="/appShare" element={<AppShare />} />

      {/* Default redirects - 最後に配置 */}
      <Route path="/" element={<Navigate to="/top" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App



